const ROUTE_CONSTANTS = {
    ROOT: "/",
    ERROR: "/error",
    HEALTH_REPORT_PURCHASE: "/health-report-purchase",
    FREE_HEALTH_REPORT_PURCHASE: "/free-health-report-purchase",
};

export default ROUTE_CONSTANTS;
